"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
var _react = _interopRequireDefault(require("react"));
var _images = _interopRequireWildcard(require("../common_features/assets/images"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StoreAlerts = props => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
    name: "Store Name",
    address: "address",
    loginType: "loginType",
    successLabel: null,
    rightButtonShow: null,
    arrowImage: _images.default.ArrowRight.default,
    everythingOkIcon: _images.everythingOkIcon.default
  }));
};
var _default = exports.default = StoreAlerts;